<template>
  <section class="sec05">
    <div class="inner">
      <!--로고배너-->
      <div class="logo_bnr">
        <!--        <ul class="logo_bnr_ul">-->
        <!--          <li class="logo_bnr_li">-->
        <!--            <div class="img_wrap">-->
        <!--              <img src="@/assets/static/images/sample06.png" alt="" />-->
        <!--            </div>-->
        <!--          </li>-->
        <!--        </ul>-->
        <swiper
          tag="ul"
          class="logo_bnr_ul"
          ref="mySwiper"
          :options="swiperOption"
        >
          <swiper-slide
            tag="li"
            class="logo_bnr_li"
            v-for="(item, index) in items"
            :key="index"
          >
            <div class="img_wrap">
              <a :href="item.url" target="_blank"><img :src="$ConstCode.getImagePath(item.imagePath)" alt="" /></a>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <!--//로고배너-->
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'main-logos-index',
  components: { Swiper, SwiperSlide },
  data: function() {
    return {
      swiperOption: {
        slidesPerView: 5,
        slideToClickedSlide: true,
        autoplay: {
          delay: 3000
        }
      },
      items: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    onSlideChange: function(index) {
      console.log('onSlideChange', index)
    },
    fetchData: async function() {
      const res = await this.$MainSvc.getListBoxBottomBanner()
      if (res.code === 1) {
        this.items = res.entity.list
      }
    }
  }
}
</script>

<style scoped></style>
